<script>
  import { isExternalUrl, correctedUrl } from "$lib/utilities/url-helpers";
  import { Button, GridContainer } from "@ObamaFoundation/of-design-system";
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  import { getContext } from "svelte";

  export let label;
  export let id;
  export let url;
  export let disabled;
  export let size;
  export let type;
  export let variant = "outline";

  let className = "";
  export { className as class };

  export let arialLabel;
  export let haspopup = false;
  export let expanded = false;

  const isContainerized = !!getContext("containerized");

  let isExternal;
  let linkToRender;

  $: {
    isExternal = isExternalUrl(url, $page?.url?.origin);
    linkToRender = correctedUrl(url);
  }
</script>

{#if isContainerized}
  <div class={className}>
    <Button
      {id}
      {label}
      {variant}
      {disabled}
      {size}
      on:click
      buttonClass="block lg:inline-block justify-center lg:justify-start"
      aria-label={arialLabel}
      aria-haspopup={haspopup}
      aria-expanded={haspopup ? expanded : null}
      type={url ? undefined : type}
      url={linkToRender}
      target={isExternal ? "_blank" : null}
      rel={isExternal ? "noopener noreferrer" : null}
    >
      <slot />
    </Button>
  </div>
{:else}
  <GridContainer containerClass={className}>
    <div>
      <Button
        {id}
        {label}
        {variant}
        {disabled}
        {size}
        on:click
        buttonClass="justify-center"
        aria-label={arialLabel}
        aria-haspopup={haspopup}
        aria-expanded={haspopup ? expanded : null}
        type={url ? undefined : type}
        url={linkToRender}
        target={isExternal ? "_blank" : null}
        rel={isExternal ? "noopener noreferrer" : null}
      >
        <slot />
      </Button>
    </div>
  </GridContainer>
{/if}
